import { render, staticRenderFns } from "./c-detail-replaced.vue?vue&type=template&id=fa9dead4&"
import script from "./c-detail-replaced.vue?vue&type=script&lang=js&"
export * from "./c-detail-replaced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports